import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function OtpForm({
  className,
  handleOtpSubmit,
  handleBackToLogin,
  isLoading,
  error,
  setCode,
  code,
  email,
  ...props
}: React.ComponentProps<"div"> & {
  handleOtpSubmit: (e: React.FormEvent) => void;
  handleBackToLogin: () => void;
  isLoading: boolean;
  error: string | null;
  setCode: (code: string) => void;
  code: string;
  email: string;
}) {
  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-full text-gray-500 text-lg gap-2">
        <svg className="animate-spin h-6 w-6 text-blue-500" viewBox="0 0 24 24">
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
            fill="none"
          />
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
          />
        </svg>
        Verifying code...
      </div>
    );
  }

  return (
    <div className={cn("flex flex-col gap-6", className)} {...props}>
      <Card>
        <CardHeader>
          <CardTitle>Verify your code</CardTitle>
          <CardDescription>
            Enter the verification code sent to {email}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleOtpSubmit}>
            <div className="flex flex-col gap-6">
              <div className="grid gap-3">
                <Label htmlFor="code">Verification code</Label>
                <Input
                  id="code"
                  type="text"
                  placeholder="12345678"
                  required
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  maxLength={8}
                  className="text-center text-lg tracking-widest"
                />
              </div>
              <div className="flex flex-col gap-3">
                <Button type="submit" className="w-full">
                  Verify code
                </Button>
                <Button
                  type="button"
                  variant="outline"
                  className="w-full"
                  onClick={handleBackToLogin}
                >
                  Back to login
                </Button>
              </div>
            </div>
            {error && <p className="text-sm text-red-500 mt-4">{error}</p>}
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
